import type { Moment } from 'moment'
import type { IntlShape } from 'react-intl'
import { INTL_DAY_MONTH_NAME_SHORT, INTL_DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'
import type { TripDateFormatters } from 'tripPlanner/components/Chat/orderTileDisplayUtils'
import { getChatActivityAge } from 'tripPlanner/utils/chatTimestamps'

export function getRecentChatTimestampLabel(
  updatedAt: string,
  intl: IntlShape,
  formatDate: TripDateFormatters['formatDate'],
  now: Moment,
): string {
  const age = getChatActivityAge(updatedAt, now)
  switch (age.unit) {
    case 'minutes':
      return intl.formatMessage({
        id: 'GzRyJKz-EP42cidhV4gu',
        defaultMessage: '{count, plural, one {#m ago} other {#m ago}}',
        description: 'Short relative time on a recent chat on the trip planner chat landing page, such as 5m ago',
      }, { count: age.count })
    case 'hours':
      return intl.formatMessage({
        id: 'Zr0aswGNZ7YhDIQOo-2e',
        defaultMessage: '{count, plural, one {#h ago} other {#h ago}}',
        description: 'Short relative time on a recent chat on the trip planner chat landing page, such as 6h ago',
      }, { count: age.count })
    case 'days':
      if (age.count === 1) {
        return intl.formatMessage({
          id: 'xdWWi1wbSP0vZP4nKAtt',
          defaultMessage: 'Yesterday',
          description: 'Relative time on a recent chat on the trip planner chat landing page when it was last updated yesterday',
        })
      }
      return intl.formatMessage({
        id: 'y16V-TynO8QwFejdd1-d',
        defaultMessage: '{count, plural, one {# day ago} other {# days ago}}',
        description: 'Relative time on a recent chat on the trip planner chat landing page, such as 2 days ago',
      }, { count: age.count })
    case 'date':
      return formatDate(updatedAt, age.sameYear ? INTL_DAY_MONTH_NAME_SHORT : INTL_DMY_CASUAL_SHORT_FORMAT)
    case 'invalid':
      return ''
  }
}
